import { Routes } from '@angular/router';
import { StoryMap } from './components/story-map/story-map';
import { StoryList } from './components/story-list/story-list';
import { StoryView } from './components/story-view/story-view';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'story-map',
    pathMatch: 'full',
  },
  // Story list
  {
    path: 'story-map',
    component: StoryMap,
  },
  {
    path: 'story-list',
    component: StoryList,
  },
  {
    path: 'story/:id',
    component: StoryView,
  },
  {
    path: 'story/:area-name/:collectionId/:title',
    component: StoryView,
  },
];
